<div class="row claim-profile manual">
    <div class="col center">
        <h1>Your profile claim <span class="block bold">has been submitted</span></h1>
        <p class="mt70">
            Our team will review your claim submission shortly and we will be in contact once this process is completed.
        </p>
    </div>
</div>